import React from "react";
import { addDays } from 'date-fns';

class RatesDashboardLegend extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="RatesDashboardLegend">
				<table className="table table-bordered table-condensed">
					<thead>
						<tr>
							<th>{I18n.t('days_out')}</th>
							<th>{I18n.t('lead_time')}</th>
							<th>{I18n.t('number_of_bookings')}</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td><a href="#" onClick={this.props.onChangeDate.bind(null, addDays(this.props.todays_date, 60))}>{I18n.t('plus_60_days')}</a></td>
							<td>{JSON.parse(this.props.sixty_days).lead_time} {I18n.t('days')}</td>
							<td>{JSON.parse(this.props.sixty_days).number_of_bookings || 0}</td>
						</tr>
						<tr>
							<td><a href="#" onClick={this.props.onChangeDate.bind(null, addDays(this.props.todays_date, 120))}>{I18n.t('plus_120_days')}</a></td>
							<td>{JSON.parse(this.props.one_hundred_twenty_days).lead_time} {I18n.t('days')}</td>
							<td>{JSON.parse(this.props.one_hundred_twenty_days).number_of_bookings || 0}</td>
						</tr>
						<tr>
							<td><a href="#" onClick={this.props.onChangeDate.bind(null, addDays(this.props.todays_date, 180))}>{I18n.t('plus_180_days')}</a></td>
							<td>{JSON.parse(this.props.one_hundred_eighty_days).lead_time} {I18n.t('days')}</td>
							<td>{JSON.parse(this.props.one_hundred_eighty_days).number_of_bookings || 0}</td>
						</tr>
					</tbody>
				</table>
			</div>
		);
	};
};

export default RatesDashboardLegend
